export default {
    addEventListener: () => {},
    fetch: async () => {
        return {
            isInternetReachable: true,
        }
    },
}